var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 0.0548096C20.1378 0.0548096 25.9451 5.862 25.9451 13C25.9451 20.138 20.1379 25.9452 12.9999 25.9452C5.86188 25.9452 0.0546875 20.138 0.0546875 13C0.0546875 5.862 5.86188 0.0548096 12.9999 0.0548096ZM12.9999 1.97245C6.89835 1.97245 1.97249 6.89839 1.97249 12.9998C1.97249 19.1013 6.89844 24.0272 12.9999 24.0272C19.1013 24.0272 24.0273 19.1013 24.0273 12.9998C24.0273 6.89839 19.1013 1.97245 12.9999 1.97245ZM12.9999 5.32852C13.5296 5.32852 13.9587 5.75794 13.9587 6.28734V12.9995C13.9587 13.2644 13.8477 13.5002 13.6741 13.6737L9.61366 17.7492C9.23909 18.1238 8.6247 18.1238 8.25013 17.7492C7.87556 17.375 7.87556 16.7603 8.25013 16.3857L12.041 12.6102V6.2876C12.041 5.75785 12.4704 5.32878 12.9998 5.32878L12.9999 5.32852Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTime);
export default __webpack_public_path__ + "static/media/total_time.c3ee29c8dfdd29ec6fbabeed2c6e1243.svg";
export { ForwardRef as ReactComponent };